class LinktagService {
  constructor() {
    this.singleLanguage = false;
  }
  setLanguagesConfig(config) {
    this.languagesConfig = config;
    this.singleLanguage = config.available.length === 1;
  }
  setCanonicalTagFromPath(urlPath, postProcess) {
    if (!this.languagesConfig) {
      return;
    }
    const availableLangs = this.languagesConfig.available;
    const defaultLang = this.languagesConfig.default;
    const currentLang = this.getCurrentLang(urlPath, availableLangs, defaultLang);
    const canonicalUrl = this.createUrl(urlPath, currentLang);
    return this.setCanonicalTagFromUrl(postProcess ? postProcess(canonicalUrl) : canonicalUrl);
  }
  setCanonicalTagFromUrl(canonicalUrl) {
    let tag = this.getCanonicalTag();
    if (!tag) {
      const createdTag = document.createElement("link");
      createdTag.setAttribute("rel", "canonical");
      tag = document.head.appendChild(createdTag);
    }
    tag.setAttribute("href", canonicalUrl);
    return tag;
  }
  getCurrentLang(url, langs, defaultLang) {
    const currentLangRegexp = new RegExp(`^/(${langs.join("|")})`);
    const matches = url.match(currentLangRegexp);
    return matches && matches[1] || defaultLang;
  }
  getCanonicalTag() {
    return document.querySelector("link[rel='canonical']");
  }
  createUrl(urlPath, lang) {
    const origin = window.location.origin;
    const slashIndex = urlPath.indexOf("/", 1);
    if (this.singleLanguage) {
      return `${origin}${urlPath}`;
    } else {
      const subIndex = slashIndex >= 0 ? slashIndex : 3;
      return `${origin}/${lang}${urlPath.substring(subIndex)}`;
    }
  }
}
const linktag = new LinktagService();

export { LinktagService, linktag };
